import { combineReducers } from "redux";
import { reducer as form } from "redux-form";
import { reducer as toastr } from "react-redux-toastr";
import { reducer as modal } from "redux-modal";
import { reducer as onboarding } from "../../onboarding";

import error from "./error";
import settings from "./settings";
import cases from "./cases";
import computation from "./computation";
import mapRequest from "./mapRequest";
import serviceWorker from "./serviceWorker";
export default () => {
  return combineReducers({
    error,
    form,
    modal,
    toastr,
    settings,
    cases,
    computation,
    mapRequest,
    serviceWorker,
    onboarding
  });
};
